export default "__VITE_ASSET__DrKSHGBr__"